import { FC, memo, useMemo } from 'react'
import { Button, ButtonProps, Center } from '@chakra-ui/react'

import { Filters } from 'components/icons'

type CustomVariant = {
  [key: string]: object
}

type Props = ButtonProps & {
  filteredFieldsCount?: number
  children: any
  customVariant?: 'IN-DRAWER' | 'DEFAULT'
}

const FilterButton: FC<Props> = ({
  children,
  filteredFieldsCount = 0,
  customVariant = 'default',
  variant = 'outline',
  ...props
}) => {
  const selectedCustomVariant = useMemo(() => {
    const customVariants: CustomVariant = {
      DEFAULT: {},
      'IN-DRAWER': {
        minWidth: { base: '100%', sm: '100%', md: '200px' },
      },
    }

    return customVariants[customVariant]
  }, [customVariant])

  return (
    <Button
      variant={variant}
      minWidth="min-content"
      bg="lighterPrimary"
      leftIcon={<Filters />}
      {...props}
      {...selectedCustomVariant}
    >
      {children}
      {filteredFieldsCount !== 0 && (
        <Center ml={2} bg="primary" color="light" rounded="full" width="20px" height="20px">
          {filteredFieldsCount}
        </Center>
      )}
    </Button>
  )
}

export default memo(FilterButton)
